
import { UserX, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface TimelineAccessDeniedProps {
  username?: string;
  onSendFriendRequest?: () => void;
  canSendRequest?: boolean;
}

const TimelineAccessDenied = ({ 
  username, 
  onSendFriendRequest, 
  canSendRequest = false 
}: TimelineAccessDeniedProps) => {
  return (
    <div className="container mx-auto py-8 px-4 flex flex-col items-center justify-center min-h-[80vh]">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="mb-6 w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto">
            <UserX className="h-8 w-8 text-red-600" />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-3">
            Keine Berechtigung
          </h1>
          
          <p className="text-gray-600 mb-6">
            Du hast keine Berechtigung, diese Timeline zu sehen. 
            {username && ` Ihr müsst Freunde sein, um ${username}s Timeline zu sehen.`}
          </p>

          {canSendRequest && onSendFriendRequest && (
            <Button 
              onClick={onSendFriendRequest}
              className="gap-2 bg-uplivion-blue hover:bg-uplivion-blue/90"
            >
              <UserPlus className="h-4 w-4" />
              Freundschaftsanfrage senden
            </Button>
          )}
          
          <div className="mt-4">
            <Button 
              variant="outline" 
              onClick={() => window.history.back()}
            >
              Zurück
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TimelineAccessDenied;
